<template>
  <v-group>
    <v-rect :zIndex='2' v-if="table.forme === 'rect'" ref="miniRect" :config="configMiniRectangle"></v-rect>
    <v-circle :zIndex='3' v-if="table.forme === 'circle'" ref="miniCircle" :config="configMiniCircle"></v-circle>
  </v-group>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MiniTable',
  props: ['table'],
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      getSelectedTables: 'newRooms/getSelectedTables',
      getModEdition: 'newRooms/getModEdition',
      getUnitGrid: 'newRooms/getUnitGrid',
      getUnitTable: 'newRooms/getUnitTable',
      getThisTableIsLock: 'newRooms/getThisTableIsLock',
      getSelectedMainService: 'newServices/getSelectedMainService',
      getSelectedDay: 'calendar/getSelectedDay',
      getCurrentResaDataTimerById: 'newReservations/getCurrentResaDataTimerById'
    }),
    getResaOnTable: function () {
      let resas = []
      if (this.table.resaId.length > 0) {
        this.table.resaId.forEach((resaId) => {
          resas.push(this.getCurrentResaDataTimerById(resaId))
        })
      } else return []
      return resas
    },
    getTableFill: function () {
      let docStyle = getComputedStyle(document.documentElement)
      let tableIsLock = this.getThisTableIsLock({
        date: this.getSelectedDay,
        service: this.getSelectedMainService,
        room: this.table.roomid,
        id: this.table.id
      })
      if (this.getModEdition && this.table.isDragging) return docStyle.getPropertyValue('--dark__line_color-light')
      else if (this.getModEdition && this.table.id === this.getSelectedTables) return docStyle.getPropertyValue('--color_blue_azure')
      else if (!this.getModEdition && this.table.id === this.getSelectedTables) return docStyle.getPropertyValue('--dark__line_color-light')
      else if (!this.getModEdition && this.table.isBooked) return docStyle.getPropertyValue('--color_dark')
      else if (!this.getModEdition && (this.getResaOnTable.length > 0)) return docStyle.getPropertyValue('--color_dark')
      else if (!this.getModEdition && tableIsLock) return docStyle.getPropertyValue('--color_red_big_dark')
      else return docStyle.getPropertyValue('--dark__line_color-light')
    },
    configMiniRectangle: function () {
      return {
        name: `${this.table.id}rectangle`,
        fill: this.getTableFill,
        cornerRadius: 5,
        width: this.table.width * this.getUnitTable,
        height: this.table.height * this.getUnitTable,
        rotation: this.table.angle,
        offset: {
          x: (this.table.width * this.getUnitTable) / 2,
          y: (this.table.height * this.getUnitTable) / 2
        },
        x: this.table.x,
        y: this.table.y
      }
    },
    configMiniCircle: function () {
      return {
        name: `${this.table.id}circle`,
        fill: this.getTableFill,
        width: this.table.width * this.getUnitTable,
        height: this.table.height * this.getUnitTable,
        x: this.table.x,
        y: this.table.y
      }
    }
  }
}
</script>

<style scoped></style>
